// Path: src\Components\HtmlFreeGames\HtmlFreeGames.jsx
import React, { useEffect, useState } from "react";
import BaseHome from "../Home/BaseHome";
import Games from "../../assets/images/games.svg";
import Game from "../../images/box.png";
import { useTranslation } from "react-i18next";
import {  getHTMLCategoryList } from "../../api/htmlFreeGames";
import ListLoader from '../Common/ListLoader';

import { kFormatter } from "../../Utilities/kFormatter";
import { base_apis } from "../../config/url";

const HtmlFreeGames = () => {
    const { t } = useTranslation();
    const [HTMLCategoryList, setHTMLCategoryList] = useState(null);
    const [loading, setLoading] = useState(true)

    const getFeatureImg = (data) => {
        return (data) ? `${base_apis?.imageUrl}${data}` : Game;
    };

    useEffect(() => {
        fetchHTMLFreeGamesList();
    }, [])

    const fetchHTMLFreeGamesList = async () => {
        setLoading(true)
        try {
            let payload = {
                sortby: "order",
                sort: "asc"
            }
            const data = (payload);
            const res= await getHTMLCategoryList(data)
            setLoading(false)
            if (res?.success && res?.data) {
                setHTMLCategoryList(res?.data)
            }
            else {
                setHTMLCategoryList([])
            }
        } catch (error) {
            setLoading(false)
        }
    };

    return (
        <BaseHome title="html free games">
            {HTMLCategoryList && HTMLCategoryList?.length ? 
                <section className="mt-4 all-games">
                    <div className="d-flex flex-wrap all-games-section" >
                        {
                            HTMLCategoryList.map((freeGame)=>{
                                return <div
                                    className="game-box"
                                    onClick={() => 
                                        {
                                            if (freeGame?.isDirect) {
                                                localStorage.setItem("DirectLink", freeGame?.link)
                                                localStorage.setItem("activeFreeGame", freeGame?.name?.toLowerCase())
                                                localStorage.setItem("activeFreeGameId", freeGame?._id)
                                                window.location.href = `/htmlFreeGames/game/${freeGame._id}`
                                            }else{
                                                localStorage.setItem("activeFreeGame", freeGame.name?.toLowerCase())
                                                localStorage.setItem("activeFreeGameId", freeGame?._id)
                                                window.location.href = `/htmlFreeGames/game-type/${freeGame._id}`
                                            }
                                        }
                                    }
                                    style={{ cursor: "pointer" }} // This adds a pointer cursor to indicate clickability
                                >
                                    <div className="px-1 pb-1 text-center">
                                    <p className="mb-0 mt-1 text-center">
                                    {freeGame?.name?.length > 15 ? (
                          <marquee>{freeGame?.name}</marquee>
                        ) : (
                            freeGame?.name
                        )}
                                        </p>
                                    </div>
                                    <div className="home-game">
                                        <div className="overlay"></div>
                                        <img className="" src={getFeatureImg(freeGame?.featuredImage)} alt="game" />
                                        <span>
                                            <img className="icon-16 me-2" src={Games} alt="game" />
                                            {kFormatter(freeGame?.totalJoinedPlayers)} played
                                        </span>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                </section>
                :
                !loading &&
                <div className='w-100 d-flex justify-content-center'><span className="text-center">{t('common.no_data_found')}</span></div>
            }
            {loading && <div className='w-100 d-flex justify-content-center'> <ListLoader/></div>}
        </BaseHome>
    );
};

export default HtmlFreeGames;
